import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeleteWebServicePayload, IEtabActivetedWebService } from "../Xserver/Services/interface";



export interface Ixserverstate {
  etabActivetedWebService: IEtabActivetedWebService[];
  filteredEtabActivetedWebService: IEtabActivetedWebService[];
  fetchingData: boolean;
}


const initialState: Ixserverstate = {
  etabActivetedWebService: [],
  filteredEtabActivetedWebService: [],
  fetchingData: true
}

export const xserverSlice = createSlice({
  name: "xservers",
  initialState: initialState,

  reducers: {

    setEtabActivetedWebService: (state, action: PayloadAction<IEtabActivetedWebService[]>) => {
      state.etabActivetedWebService = action.payload;
    },

    setFilteredEtabActivetedWebService: (state, action: PayloadAction<IEtabActivetedWebService[]>) => {
      state.filteredEtabActivetedWebService = action.payload;
    },

    setFetchingData: (state, action: PayloadAction<boolean>) => {
      state.fetchingData = action.payload;
    },

    updateEtabActivetedWebService: (state, action: PayloadAction<IEtabActivetedWebService>) => {
      const newArray = state.etabActivetedWebService.map((i: IEtabActivetedWebService) =>
        i.codeEtab === action.payload.codeEtab
          ? action.payload
          : i
      );

      state.etabActivetedWebService = newArray;
      state.filteredEtabActivetedWebService = newArray;
    },

    // deleteEtabActive: (state, action: PayloadAction<string>) => {
    //   state.etabActivetedWebService = state.etabActivetedWebService.filter((etab: IEtabActivetedWebService) => etab.codeEtab !== action.payload);
    //   state.filteredEtabActivetedWebService = state.filteredEtabActivetedWebService.filter((etab: IEtabActivetedWebService) => etab.codeEtab !== action.payload);
    // },


    deleteEtabActive: (state, { payload }: PayloadAction<DeleteWebServicePayload>) => {
      const match = (r: IEtabActivetedWebService) =>
        r.codeEtab === payload.codeEtab &&
        r.anneeScolaire === payload.anneeScolaire &&
        r.idService === payload.idService;

      state.etabActivetedWebService =
        state.etabActivetedWebService.filter((r) => !match(r));

      state.filteredEtabActivetedWebService =
        state.filteredEtabActivetedWebService.filter((r) => !match(r));
    },
  },
});

export const { deleteEtabActive, setFetchingData, setEtabActivetedWebService, updateEtabActivetedWebService, setFilteredEtabActivetedWebService } = xserverSlice.actions;

export default xserverSlice.reducer;
